module.exports = __webpack_public_path__ + "media/KikiY.9e2b3212.mp3";